var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 42,
    viewBox: "0 0 48 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20L11 12L33 13L34 32L24 41C24 41 24.1614 33.9612 16 27C7.83864 20.0388 0 20 0 20Z",
    fill: "#A0041E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.36236e-05 41.0001C-7.36236e-05 41.0001 -0.0921044 31.4986 3.99993 28.0001C8.09196 24.5016 18.9999 25.0001 18.9999 25.0001C18.9999 25.0001 19.0635 34.5259 14.9999 38.0001C10.9363 41.4743 -7.36236e-05 41.0001 -7.36236e-05 41.0001Z",
    fill: "#FFAC33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 36C14.0376 36 17 34.4853 17 32C17 29.5147 14.0376 27 11 27C7.96243 27 6 29.5147 6 32C6 34.4853 7.96243 36 11 36Z",
    fill: "#FFCC4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 0.999751C47.9999 0.999751 34.3257 0.60108 17.9999 11.9998C9.83696 17.6991 10.2789 28.72 12.9999 30.9998C15.7209 33.2795 27.1974 32.839 33.9999 25.9998C47.6047 12.3213 47.9999 0.999751 47.9999 0.999751Z",
    fill: "#55ACEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 7C33.8759 7 31.8219 8.36374 31 10C31.657 9.73259 32.2331 9 33 9C35.891 9 38 11.3978 38 14C38 14.6903 38.2958 15.4098 38 16C39.8178 15.2614 41 13.9119 41 12C41 9.39777 38.891 7 36 7Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 32.9999C9.99999 32.9999 9.6065 28.1279 11 26.9999C12.3935 25.8718 29.6079 14.8729 31 15.9999C32.3921 17.1268 18.3935 30.8718 17 31.9999C15.6065 33.1279 9.99999 32.9999 9.99999 32.9999Z",
    fill: "#A0041E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector2.fa2e57826d614bab4d1985106bdee0d0.svg";
export { ForwardRef as ReactComponent };